import clsx, { ClassValue } from 'clsx'
import { PropsWithChildren } from 'react'

export type CardProps = PropsWithChildren<{
  className?: ClassValue
  compact?: boolean
}>

export function Card (props: CardProps) {
  const { className, compact, children } = props

  return (
    <div
      className={clsx(
        'card',
        'card-border',
        'bg-base-100',
        'shadow-xs',
        compact && 'card-sm',
        className
      )}
    >
      {children}
    </div>
  )
}
